import dashboard from './dashboard.png';
import coupons from './coupons.png';
import transactions from './transactions.png';
import users from './users.png';
import wallets from './wallets.png';
import partnerShops from './partnerShops.png';
import locations from './locations.png';
export const bannerImages = {
    dashboard: dashboard,
    coupons: coupons,
    transactions: transactions,
    users: users,
    wallets: wallets,
    partnerShops: partnerShops,
    locations: locations
};
